import React from "react";
import { CYTCard } from "./card.js";
import { Layout, navigateToState } from "./layout.js";
import firebase from "./CYTFirebase.js";
import { DiscussionEmbed } from "disqus-react";

const dataStore = require("./dataStore.js");

function handleSearch(e) {
  var st = {};
  st.query = e.target.value !== "" ? e.target.value : null;
  navigateToState(st);
}

const BASEURL = "https://cerdos-trufas.firebaseapp.com";
export function CYTPlace({ placeId }) {
  const [place, setPlace] = React.useState(undefined);

  console.debug(placeId);

  dataStore.getProvider(placeId).then(foundPlace => {
    console.log("Found Place", foundPlace);
    setPlace(foundPlace);
  });

  if (place === undefined) {
    return <p>Loading....</p>;
  }
  if (place === null) {
    return <p> Place {placeId} </p>;
  }
  const url = `${BASEURL}/p/${place.id}`;

  return (
    <Layout firebase={firebase} handleSearch={handleSearch}>
      <CYTCard provider={place} />
      <DiscussionEmbed
        shortname="cerdos-y-trufas"
        config={{
          url: url,
          identifier: place.id,
          title: place.name,
          language: "es_AR" //e.g. for Traditional Chinese (Taiwan)
        }}
      />
    </Layout>
  );
}
